export class BarChartData {
    bars: BarData[]

    constructor() {
        this.bars = []
    }

    add(name: string, description: string, color: string = "#555", label: string = "", value: number = 0, units: string = "") {
        this.bars.push(new BarData(name, description, color, label, value, units))
    }
}

class BarData {
    name: string
    description: string
    color: string
    label: string

    value: number
    units: string

    constructor(name: string, description: string, color: string, label: string, value: number, units: string) {
        this.name = name
        this.description = description
        this.color = color
        this.label = label

        this.value = value
        this.units = units
    }
}